import { render } from "./UserSettingsManager.vue?vue&type=template&id=75219cc5&scoped=true&lang=pug"
import script from "./UserSettingsManager.vue?vue&type=script&lang=ts"
export * from "./UserSettingsManager.vue?vue&type=script&lang=ts"

import "./UserSettingsManager.vue?vue&type=style&index=0&id=75219cc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75219cc5"

export default script